import { generatePath } from 'react-router-dom';
import { createDatasetSlice, ResponseMapping } from 'src/redux/helpers';
import { pepApiRequest, RequestMethod } from 'src/services';
import {
  API_SOLUTION_SITES,
  SOLUTIONS_STORE,
  SOLUTIONS_STORE_SITES,
} from '../constants';

const api = (solutionId: string) =>
  pepApiRequest({
    method: RequestMethod.Get,
    url: generatePath(API_SOLUTION_SITES, { solutionId }),
  });

const solutionSiteSlice = createDatasetSlice({
  api,
  storeName: SOLUTIONS_STORE,
  actionName: SOLUTIONS_STORE_SITES,
  responseMapping: ResponseMapping.Default,
});

export default solutionSiteSlice;
